class Upload{
    constructor(){
        const _this = this;
        _this.handleUploadCV();
        _this.handleUploadFile();
        // Add MutationObserver
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            node.querySelectorAll('.upload-cv').forEach(function (item) {
                                _this.handleUploadCV();
                            })
                            node.querySelectorAll('.upload-file').forEach(function (item) {
                                _this.handleUploadFile();
                            })
                        }
                    });
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    handleUploadCV = function(){
        const uploadCV = document.querySelector('.upload-cv');
        if (uploadCV && !uploadCV.classList.contains('upload-initialized')){
            uploadCV.classList.add('upload-initialized')

            let ginput_preview_list = uploadCV.querySelector('.ginput_preview_list');
            if (ginput_preview_list){
                ginput_preview_list.remove();
            }else{
                return;
            }

            const containerUploadCV = uploadCV.querySelector('.ginput_container_fileupload');
            const label = document.createElement('label');
            label.classList.add('label-upload-cv');

            const iconLabel = document.createElement('span');
            iconLabel.style.backgroundImage = `url('data:image/svg+xml,<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="%23C8EBF8"/><path d="M16.1608 17.4881H15.3833C13.6875 17.4881 12.3125 18.8631 12.3125 20.5589V24.6214C12.3125 26.3164 13.6875 27.6914 15.3833 27.6914H24.6583C26.3542 27.6914 27.7292 26.3164 27.7292 24.6214V20.5506C27.7292 18.8597 26.3583 17.4881 24.6675 17.4881H23.8817" stroke="%23015DAC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.0182 11.8252V21.8594" stroke="%23015DAC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5898 14.2656L20.019 11.8256L22.449 14.2656" stroke="%23114A86" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')`;
            iconLabel.classList.add('icon-upload');

            const txtLabel = document.createElement('span');
            txtLabel.classList.add('label-custom-upload');
            const desc = uploadCV.querySelector(':scope > .gfield_description');

            txtLabel.innerHTML = desc.innerHTML || 'Upload a file or drag and drop here';
            label.appendChild(iconLabel);
            label.appendChild(txtLabel);

            containerUploadCV.insertBefore(label, containerUploadCV.firstChild);

            const inputUploadCV = uploadCV.querySelector('input[type="file"]');
            inputUploadCV.addEventListener('change', ({target}) => {
                let file = target.files[0];
    
                const fragmentUploaded = uploadCV.querySelector('.file-value');
    
                if (fragmentUploaded){
                    fragmentUploaded.remove();
                }
    
    
                if (file){
                    let fileName = file.name;
                    let fileSize = file.size;
    
                    const fragment = document.createDocumentFragment();
                    const fileValueElement = document.createElement('div');
                    fileValueElement.classList.add('file-value');
        
                    const icon = document.createElement('div');
                    icon.classList.add('icon');
                    icon.style.backgroundImage = `
                        url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0 0 30 30"><path fill="%231C3687" d="M24.707,8.793l-6.5-6.5C18.019,2.105,17.765,2,17.5,2H7C5.895,2,5,2.895,5,4v22c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2 V9.5C25,9.235,24.895,8.981,24.707,8.793z M18,10c-0.552,0-1-0.448-1-1V3.904L23.096,10H18z"></path></svg>')
                    `;
                    icon.style.backgroundSize = "contain";
                                    
                    fileValueElement.appendChild(icon);
                    const detailsDiv = document.createElement('div');
                    detailsDiv.classList.add('details');
    
                    const detailsText = document.createElement('span');
                    detailsText.classList.add('name');
                    detailsText.innerHTML = `${fileName} &bull; Uploaded (${(fileSize / 1024).toFixed(2)}KB)`;
                    detailsDiv.appendChild(detailsText);
                    fileValueElement.appendChild(detailsDiv);
    
                    fragment.appendChild(fileValueElement);
    
                    uploadCV.appendChild(fragment);
                }
            })
        }
    }
    handleUploadFile = function(){
        const uploadFiles = document.querySelectorAll('.upload-file');
        if (!uploadFiles && uploadFiles.length <= 0) return;

        uploadFiles.forEach((uploadFile) => {
            const maxAllowedFiles = uploadFile.dataset.maxfiles ? uploadFile.dataset.maxfiles : null; 
    
            if (uploadFile && !uploadFile.classList.contains('upload-initialized')){
                uploadFile.classList.add('upload-initialized')
    
                const containerUploadFile = uploadFile.querySelector('.upload-file-wrapper');
                if (!containerUploadFile){return;}
                const inputUploadFile = containerUploadFile.querySelector('input[type="file"]');
    
                containerUploadFile.addEventListener("click", () => inputUploadFile.click());
    
                containerUploadFile.addEventListener("dragover", (e) => {
                    e.preventDefault();
                    containerUploadFile.classList.add("dragover");
                });
    
                containerUploadFile.addEventListener("dragleave", () => {
                    containerUploadFile.classList.remove("dragover");
                });
    
                containerUploadFile.addEventListener("drop", (e) => {
                    e.preventDefault();
                    containerUploadFile.classList.remove("dragover");
                    handleFiles(e.dataTransfer.files);
                });
    
                inputUploadFile.addEventListener('change', ({target}) => {
                    const fragmentUploaded = uploadFile.querySelector('.upload-file-selected');
                    if (fragmentUploaded){
                        fragmentUploaded.innerHTML = "";
                    }
                    handleFiles(target.files)
                })
    
                function handleFiles(files){
                    const fragmentUploaded = uploadFile.querySelector('.upload-file-selected');
                    
                    for(let i = 0; i < files.length; i++ ){
                        if (maxAllowedFiles && i >= maxAllowedFiles) break;
                        let file = files[i];
                        if (file){
                            let fileName = file.name;
                            let fileSize = file.size;
            
                            const fragment = document.createDocumentFragment();
                            const fileValueElement = document.createElement('div');
                            fileValueElement.classList.add('file-value');
                
                            const icon = document.createElement('div');
                            icon.classList.add('icon');
                            icon.style.backgroundImage = `
                                url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0 0 30 30"><path fill="%23A2550B" d="M24.707,8.793l-6.5-6.5C18.019,2.105,17.765,2,17.5,2H7C5.895,2,5,2.895,5,4v22c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2 V9.5C25,9.235,24.895,8.981,24.707,8.793z M18,10c-0.552,0-1-0.448-1-1V3.904L23.096,10H18z"></path></svg>')
                            `;
                            icon.style.backgroundSize = "contain";
                                            
                            fileValueElement.appendChild(icon);
                            const detailsDiv = document.createElement('div');
                            detailsDiv.classList.add('details');
            
                            const detailsText = document.createElement('span');
                            detailsText.classList.add('name');
                            detailsText.innerHTML = `<span class="name-file">${fileName} (${(fileSize / 1024).toFixed(2)}KB)</span><span class="name-status">Uploaded</span>`;
                            detailsDiv.appendChild(detailsText);
                            fileValueElement.appendChild(detailsDiv);
            
                            fragment.appendChild(fileValueElement);
            
                            fragmentUploaded.appendChild(fragment);
                        }
                    }
                }
            }

        })

    }
}

export default Upload;